module.exports = __webpack_public_path__ + "media/images/area-badges/circular-economies-728b4a7a935431b5d49c5aa0c3b9e6d5.svg";